import React from 'react';

import { Attribute } from 'types/Breaker';

type Props = {
  activeFilters: Attribute[];
  removeFilter: (attribute: Attribute) => void;
  clearFilters: () => void;
};

const ActiveFilters = ({ activeFilters, removeFilter, clearFilters }: Props) => {
  return (
    <div className="active-filter-container">
      {activeFilters.map(({ traitType, value }) => {
        const displayValue = traitType === 'Canon' ? 'Canon Breaker' : value;
        return (
          <span
            key={`${traitType}-${value}`}
            className="active-filter-badge mb-1"
            onClick={() => {
              removeFilter({ traitType, value });
            }}
          >
            {displayValue}
            <button type="button" className="btn-close btn-close-white" aria-label="Close"></button>
          </span>
        );
      })}

      {activeFilters.length > 0 && (
        <span className="clear-all-filters-button mb-1" onClick={clearFilters}>
          Clear All
        </span>
      )}
    </div>
  );
};

export default ActiveFilters;
